import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Powerhouse Refunds · Not a law firm · Refunds are not guaranteed</p>
        <nav className="flex items-center gap-5">
          <Link to="/terms" className="hover:text-slate-900" data-testid="footer-terms-link">Terms</Link>
          <Link to="/privacy" className="hover:text-slate-900" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/playbooks" className="hover:text-slate-900" data-testid="footer-playbooks-link">Playbooks</Link>
          <Link to="/chargeback-guide" className="hover:text-slate-900" data-testid="footer-chargeback-link">Chargeback guide</Link>
        </nav>
      </div>
    </footer>
  );
}
